import SectionHeading from "./SectionHeading";
import { formatChecklist, formatGoodExample, formatBadExample } from "@/mocks/home";

export default function FormatSection() {
  return (
    <section id="format" className="w-full bg-background-100 py-16 md:py-24 scroll-mt-20">
      <div className="w-full px-4 md:px-8">
        <SectionHeading
          eyebrow="格式要求"
          title="这样写，编辑一眼就能看懂你的爆料"
          desc="格式不是形式主义。信息越清晰、材料越原始，核验越快，发布也越快。"
        />

        <div className="mt-12 grid grid-cols-1 lg:grid-cols-12 gap-8">
          <div className="lg:col-span-5 p-6 md:p-7 rounded-lg bg-background-50 border border-background-200">
            <h3 className="font-heading font-bold text-lg text-foreground-950 flex items-center gap-2">
              <i className="ri-list-check-2 text-primary-600"></i>
              投稿必备清单
            </h3>
            <ul className="mt-5 space-y-3.5">
              {formatChecklist.map((item, index) => (
                <li key={item} className="flex items-start gap-3">
                  <span className="w-6 h-6 shrink-0 rounded-full bg-primary-100 text-primary-800 text-xs font-bold flex items-center justify-center">
                    {index + 1}
                  </span>
                  <span className="text-sm text-foreground-700 leading-relaxed">{item}</span>
                </li>
              ))}
            </ul>
          </div>

          <div className="lg:col-span-7 flex flex-col gap-5">
            <article className="p-6 rounded-lg bg-background-50 border border-secondary-300">
              <div className="flex items-center gap-2">
                <span className="w-8 h-8 rounded-md flex items-center justify-center bg-secondary-500 text-background-50">
                  <i className="ri-check-line text-lg"></i>
                </span>
                <h3 className="font-heading font-bold text-base text-foreground-950">
                  推荐写法
                </h3>
              </div>
              <p className="mt-4 text-sm text-foreground-700 leading-relaxed">
                {formatGoodExample}
              </p>
              <p className="mt-4 text-xs text-secondary-700 flex items-start gap-2">
                <i className="ri-lightbulb-line mt-0.5"></i>
                时间、地点、材料、诉求齐全，编辑可直接进入核验环节。
              </p>
            </article>

            <article className="p-6 rounded-lg bg-accent-50 border border-accent-200">
              <div className="flex items-center gap-2">
                <span className="w-8 h-8 rounded-md flex items-center justify-center bg-accent-500 text-background-50">
                  <i className="ri-close-line text-lg"></i>
                </span>
                <h3 className="font-heading font-bold text-base text-foreground-950">
                  不建议的写法
                </h3>
              </div>
              <p className="mt-4 text-sm text-foreground-700 leading-relaxed">
                {formatBadExample}
              </p>
              <p className="mt-4 text-xs text-accent-700 flex items-start gap-2">
                <i className="ri-error-warning-line mt-0.5"></i>
                只有情绪与结论，没有任何可核验信息，通常会被直接退回。
              </p>
            </article>
          </div>
        </div>
      </div>
    </section>
  );
}